import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

import { ModalType } from '@data/enum';
import { IModalOption } from '@data/schema';

const ICON_MAP: Record<string, string> = {
    [ModalType.DANGER]:  'mdi-trash-can-outline',
    [ModalType.WARNING]: 'mdi-alert-outline',
    [ModalType.INFO]:    'mdi-information-outline',
};

@Component({
    selector: 'app-confirm-modal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './confirm-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmModalComponent implements OnInit {
    public readonly bsModalRef = inject(BsModalRef);

    isConfirmed: Subject<boolean> = new Subject<boolean>();

    options: IModalOption = {
        type: ModalType.WARNING,
        title: '',
        description: '',
        showConfirmButton: true,
        showCloseButton: true,
        confirmButtonText: 'Confirm',
        closeButtonText: 'Cancel',
    };

    customOptions!: Partial<IModalOption>;

    get iconClass(): string {
        return ICON_MAP[this.options.type] ?? 'mdi-help-circle-outline';
    }

    ngOnInit(): void {
        this.options = { ...this.options, ...this.customOptions };
    }

    onConfirm(confirmed: boolean): void {
        this.isConfirmed.next(confirmed);
        this.bsModalRef.hide();
    }
}
